import React, { useEffect, useState } from 'react'
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import './globalStyles.css'
import './swimlane.css'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import useAxios from 'axios-hooks'
import AddSection from '../addSection'
import { encodeURI } from 'js-base64'
import { useTranslation } from 'react-i18next'
import { EMPTY_STRING_HASH } from '../../../utils/constants'
import CustomImage from '../../customImage/customImage'

const ListenLoungeCards = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  onDelete,
  onSwap,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const {
    customNavigate,
    isBrowser,
    XL_SIZE,
    LG_SIZE,
    SM_SIZE,
    CONTENT_FILTER_XAVIER,
    KalingoLeftArrow,
    KalingoRightArrow,
    getTemplateImage,
    AudioIcon,
    VideoPlaceholder,
  } = useTemplateHook()
  const [visibleSlides, setVisibleSlides] = useState(2)
  const [contentData, setContentData] = useState([])
  const language = localStorage.getItem('language') || 'en'
  const { t } = useTranslation()

  const [{ data: contentList }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  const handleResize = () => {
    if (window.innerWidth >= XL_SIZE) {
      setVisibleSlides(7.5)
    } else if (window.innerWidth < XL_SIZE && window.innerWidth >= LG_SIZE) {
      setVisibleSlides(6.5)
    } else if (window.innerWidth < LG_SIZE && window.innerWidth >= SM_SIZE) {
      setVisibleSlides(4)
    } else {
      setVisibleSlides(2)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const getDynamicFilters = (autoPayload) => {
    let obj = {}

    let ownersObj = autoPayload.find((info) => info.type === 'owners')

    if (ownersObj) {
      obj['owners'] = ownersObj?.values
    }

    return obj
  }

  useEffect(() => {
    if (!isEmpty(data.content_data) || !isEmpty(data.auto_payload)) {
      let filterPayload =
        data.type === 'STATIC'
          ? { content_ids: data.content_data }
          : {
              system_defined: data.auto_payload.filter((info) => info.type === 'system_defined'),
              custom_defined: data.auto_payload.filter((info) => info.type === 'custom_defined'),
              audio_types: ['SPA', 'MPAP', 'MPAC', 'PLAYLIST'],
              ...getDynamicFilters(data.auto_payload),
            }

      contentListCall({
        data: {
          filters: filterPayload,
          page: 1,
          order_by:
            data.type === 'STATIC'
              ? ''
              : data?.order_by === 'title'
              ? `title.${language}`
              : data?.order_by,
          reverse: data.type === 'STATIC' ? '' : data?.reverse,
          page_size: 15,
        },
      })
    } else {
      setContentData([])
    }
  }, [data])

  useEffect(() => {
    if (contentList && contentList.success) {
      if (data.type === 'STATIC') {
        contentList?.data.sort((a, b) => {
          let sortingArr = data.content_data
          return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
        })
      }
      setContentData(contentList.data)
    }
  }, [contentList])

  const handleSeeMore = () => {
    let payloadObj = {
      filters: {},
      order_by:
        data.type === 'STATIC'
          ? ''
          : data?.order_by === 'title'
          ? `title.${language}`
          : data?.order_by,
      reverse: data.type === 'STATIC' ? '' : data?.reverse,
    }
    payloadObj.filters =
      data.type === 'STATIC'
        ? {
            content_ids: data.content_data,
          }
        : {
            system_defined: data.auto_payload.filter((info) => info.type === 'system_defined'),
            custom_defined: data.auto_payload.filter((info) => info.type === 'custom_defined'),
          }
    const encoded = encodeURI(JSON.stringify(payloadObj))
    customNavigate(
      'DIRECT',
      `/content/filter/${encodeURI(data.name || EMPTY_STRING_HASH)}?filters=${encoded}`,
      isEdit,
    )
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleClick = (data) => {
    if (isEdit) return
    if (data.video_type === 'PLAYLIST' || data.audio_type === 'PLAYLIST') {
      customNavigate('DIRECT', `/playlist/${data.content_id}`)
      return
    }
    if (data.video_type === 'MPVP' || data.audio_type === 'MPAP') {
      customNavigate('DIRECT', `/parent-content/${data.content_id}`)
    } else {
      customNavigate('DIRECT', `/content/${data.content_id}`)
    }
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      className={`${isEdit && hoverState && 'component-hover-class'} relative py-2 xl:py-6`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
        zIndex: 1,
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onEdit={() => handleModal()}
          onDelete={() => onDelete(id)}
          onCopy={() => onCopy(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
        />
      )}

      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={85}
        totalSlides={contentData.length}
        visibleSlides={visibleSlides}
        step={visibleSlides}
      >
        <div
          style={{
            padding: '0 3.66032%',
          }}
          className="flex items-baseline"
        >
          <p
            // style={{ color: isCustomTemplate ?  : '#fff' }}
            style={{
              color: getStyleValue('heading', 'color', theme.c3),
              fontFamily: getStyleValue('heading', 'font', ''),
              textAlign: getStyleValue('heading', 'alignment', ''),
            }}
            className={`xl:text-2xl md:text-xl text-xs font-bold w-full ${getStyleValue(
              'heading',
              'font_format',
              'font-bold',
            )}`}
          >
            {data?.name}
            {contentData.length > 14 && (
              <span
                style={{ cursor: 'pointer' }}
                className={
                  'text-blue-400 text-xs md:text-md  ml-2 cursor-pointer hover:opacity z-30 mt-3'
                }
                onClick={handleSeeMore}
              >
                {t('see_more')}
              </span>
            )}
          </p>
        </div>
        <div
          className={
            isEmpty(contentData)
              ? 'animate-pulse swimlane-container-dock listen-lounge-cards-class h-[8.5rem] md:h-[12rem]'
              : 'swimlane-container-dock listen-lounge-cards-class h-[8.5rem] md:h-[12rem]'
          }
          style={{
            backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
          }}
        >
          <Slider
            // style={{
            //   minHeight: 'unset',
            //   maxHeight: '280px',
            // }}
            className="audio-swimlane pt-2 xl:pt-3"
          >
            {contentData.map((item, index) => {
              return (
                <Slide key={index} index={index} className="">
                  <div className="">
                    <div
                      className="relative overflow-hidden transform rounded-lg transition duration-500 ease z-0 cursor-pointer "
                      onClick={() => handleClick(item)}
                      style={{
                        background: getStyleValue('card_style', 'background_color', theme.c1),
                      }}
                    >
                      <div className="bg-black rounded-lg overflow-hidden flex justify-center relative">
                        {item.asset_type === 'AUDIO' && (
                          <img
                            style={{ width: '24px', height: '24px' }}
                            className="absolute right-0 m-2 z-10"
                            src={AudioIcon}
                            alt="AudioIcon"
                          />
                        )}
                        <div className="static-img-scale">
                          <CustomImage
                            imageUrl={getTemplateImage(item?.poster)}
                            imgClass="aspect-square object-center"
                            loaderClass={'h-20 md:h-32'}
                            imgAlt={item.title}
                            errorPlaceholder={VideoPlaceholder}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          color: getStyleValue('card_style', 'color', theme.c4),
                          fontFamily: getStyleValue('card_style', 'font', ''),
                        }}
                        className="mt-[6px]"
                      >
                        <div className="flex justify-between items-center ">
                          <p
                            className={`text-xs md:text-[15px] ${getStyleValue(
                              'card_style',
                              'font_format',
                              'font-bold',
                            )} line-clamp-1 mb-0`}
                          >
                            {item.title}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slide>
              )
            })}
          </Slider>
          {isBrowser && (
            <>
              {contentData.length > visibleSlides ? (
                <ButtonBack className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                      top: '2.5%',
                    }}
                    className="kalingo-left-arrow-small flex items-center justify-center"
                  >
                    <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
                  </div>
                </ButtonBack>
              ) : null}
              {contentData.length > visibleSlides ? (
                <ButtonNext className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                      top: '2.5%',
                    }}
                    className="kalingo-right-arrow-small flex items-center justify-center"
                  >
                    <img
                      src={KalingoRightArrow}
                      style={{ height: '37px' }}
                      alt="KalingoLeftArrow"
                    />
                  </div>
                </ButtonNext>
              ) : null}
            </>
          )}
        </div>
      </CarouselProvider>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(ListenLoungeCards)
